window.jobsTitlesEqualizer = function jobsTitlesEqualizer() {

  const CONFIGS = [
    {
      selector: '.explore-roles-sec__result-grid',
      columns: 2,
      breakpoint: 900
    },
    {
      selector: '.explore-roles-sec__slider .on-resize-type',
      columns: 3,
      breakpoint: 1022
    }
  ];

  function equalize(container, columns, breakpoint) {

    const cards = container.querySelectorAll('.job-card');
    if (!cards.length) return;

    cards.forEach(card => {
      const title = card.querySelector('.job-card__title');
      if (title) title.style.minHeight = '';
    });

    if (window.innerWidth <= breakpoint) return;

    for (let i = 0; i < cards.length; i += columns) {

      const row = Array.from(cards).slice(i, i + columns);
      let maxHeight = 0;

      row.forEach(card => {
        const title = card.querySelector('.job-card__title');
        if (title) {
          maxHeight = Math.max(maxHeight, title.offsetHeight);
        }
      });

      row.forEach(card => {
        const title = card.querySelector('.job-card__title');
        if (title) {
          title.style.minHeight = maxHeight + 'px';
        }
      });
    }
  }

  function run() {
    CONFIGS.forEach(cfg => {
      const container = document.querySelector(cfg.selector);
      if (!container) return;

      equalize(container, cfg.columns, cfg.breakpoint);
    });
  }

  if (!window._jobsTitlesEqualizerInit) {
    window.addEventListener('load', run);
    window.addEventListener('resize', run);
    window._jobsTitlesEqualizerInit = true;
  }

  run();
};

jobsTitlesEqualizer();